module.exports = __webpack_public_path__ + "static/media/tabbing-effect-shap.fc4e0bf0.svg";